export default class RwGenericDialog {
    show: boolean = false;
    title: string = "";
    text: string = "";
    icon: string = "";
    confirmCallback: Function | null = null;
    onCloseCallback: Function | null = null;
}
